import * as React from 'react'
import { IStageProps } from 'app/types'
import Clock from 'app/comp/clock'
import StageCounter from 'app/comp/stage-counter'
import DocumentEventHandler from 'app/comp/document-event-handler'
import Hint from 'app/comp/hint'
import * as Sound from 'app/service/sound'


const WORD = 'loading'


export default class LoadingStage extends React.Component<IStageProps, {
  count: number
  showHint: boolean
}> {

  timeout: number

  constructor(props) {
    super(props)

    this.state = {
      count: 0,
      showHint: false
    }
  }

  componentDidMount() {
    this.timeout = window.setTimeout(() => {
      this.setState({showHint: true})
    }, 10000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  handleKeyPress = (event) => {
    const { count } = this.state

    const k = String.fromCharCode(event.which)

    if (k == WORD[count]) {

      if (count < WORD.length - 1) {
        Sound.playNote(count)
      }

      this.setState({count: count + 1})

      if (count == WORD.length - 1) {
        this.props.onNext()
      }
    }
  }

  render() {
    const {
      count,
      showHint
    } = this.state

    return (
      <div className="container">

        <Hint delay={1 * 30 * 1000} text="I've been waiting a long time! My fingers are itching to *type* something out." onAddTime={this.props.onAddTime} />

        <DocumentEventHandler
          onKeyPress={this.handleKeyPress}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <h1 style={{color: '#aaa', fontSize: '10vw'}}>
          {WORD.split('').map((l, i) =>
            <span key={i} style={{color: count > i ? '#222' : '#ccc'}}>{l}</span>
          )}
          {showHint &&
            <span>..?</span>
          }
          {!showHint &&
            <span>...</span>
          }
        </h1>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/loading.tsx